import { getCartList, addToCart, deleteCartItem, updateCartItemQuantity } from '@/api/userinfo'

const cartModule = {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    totalCount: state => {
      if (!state.items || !Array.isArray(state.items)) return 0;
      let count = 0;
      state.items.forEach(cart => {
        (cart.items || []).forEach(item => {
          count += Number(item.product_spec_quantity) || 0;
        });
      });
      return count;
    },
    totalPrice: state => state.items.reduce((sum, item) => sum + item.price * item.quantity, 0)
  },
  mutations: {
    SET_CART_ITEMS(state, items) {
      state.items = items
    }
  },
  actions: {
    async fetchCart({ commit }) {
      const res = await getCartList()
      commit('SET_CART_ITEMS', res|| [])
    },
    async addToCart({ dispatch }, product) {
      await addToCart(product)
      await dispatch('fetchCart')
    },
    async removeFromCart({ dispatch }, id) {
      await deleteCartItem(id)
      await dispatch('fetchCart')
    },
    async updateQuantity({ dispatch }, { id, quantity }) {
      await updateCartItemQuantity(id, quantity)
      await dispatch('fetchCart')
    },
    async updateRemark({ dispatch }, { id, quantity, remark }) {
      await updateCartItemQuantity(id, quantity, remark)
      await dispatch('fetchCart')
    }
  }
}

export default cartModule